import React, { lazy } from "react";
import { Route, Switch } from "react-router-dom";
const StoreDirectory = lazy(() => import("Components/StoreDirectory"));
const ATMDirectory = lazy(() => import("Components/ATMDirectory"));

const StoreDirectoryRoutes = () => {
  return (
    <Switch>
      <Route path="/storedirectory/atm" component={ATMDirectory} />
      <Route path="/storedirectory/" component={StoreDirectory} />
    </Switch>
  );
};

export default StoreDirectoryRoutes;
